import React, { useEffect } from "react";
import _ from "lodash";
import ButtonList from "../../../components/ButtonList";
import LinkButton from "../../../components/LinkButton";
import DropDownList from "../../../components/DropDownList";

import styles from "./RecordTable.module.scss";

const RecordOverrideOptions = ({
  onClickRecordOverrideAction,
  onClickRecordOverrideButton,
  detailsMap,
  disableInactiiveAndInvalid,
  disableReplace,
  extension,
  isMultipleAttributeOverride = false,
  selectedOverrides
}) => {
  const [rowPopOverVisible, setRowPopOverVisible] = React.useState(false);
  const [overrideOptions, setOverrideOptions] = React.useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      event.preventDefault();
      event.stopPropagation();
      if (rowPopOverVisible && event.target.tagName !== "P") {
        setRowPopOverVisible(false);
      }
      if (overrideOptions && event.target.tagName !== "P") {
        setOverrideOptions(false);
      }
    }
    //Bind the event listener
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [rowPopOverVisible, overrideOptions]);

  const handleOnclickAction = (event, action) => {
    event.stopPropagation();
    event.preventDefault();
    detailsMap["Mark as"] = action;
    if (isMultipleAttributeOverride) {
      const detailsMapCopy = _.cloneDeep(detailsMap);
      onClickRecordOverrideAction(detailsMapCopy);
    } else {
      onClickRecordOverrideAction(detailsMap);
    }
    setRowPopOverVisible(false);
    setOverrideOptions(false);
  };

  const handleValue = (selectedOverrides, detailsMap) => {
    const field = detailsMap.Field;

    // since birthDate, gender, and multipleBirth are single valued, there should only be one value in the list.
    if (
      selectedOverrides &&
      ["Date of Birth", "Gender", "Multiple Birth"].includes(field) &&
      !_.isEmpty(selectedOverrides)
    ) {
      return selectedOverrides[0]["Mark as"];
    }

    // multiple valued attributes have ids assigned to them, find the id of the current element in the list.
    if (
      selectedOverrides &&
      selectedOverrides.some(item => item.id === detailsMap.id)
    ) {
      return selectedOverrides.find(item => item.id === detailsMap.id)[
        "Mark as"
      ];
    }

    // if not found, return "No Change", as there is currently no override designation for this element.
    return "No Change";
  };

  let divWidth = detailsMap.Field.includes("Address") ? "25%" : "10%";

  const multipleAttributeOverride = () => {
    return (
      <div>
        <div style={{ position: "relative", width: divWidth, float: "left" }}>
          {!extension ||
            (extension.length === 0 && (
              <DropDownList
                onChange={event => {
                  handleOnclickAction(event, event.target.value);
                }}
                value={handleValue(selectedOverrides, detailsMap)}
              >
                <DropDownList.Item value="No Change">
                  No Change
                </DropDownList.Item>
                {!disableInactiiveAndInvalid && (
                  <DropDownList.Item value="Invalid">Invalid</DropDownList.Item>
                )}
                {!disableInactiiveAndInvalid && detailsMap.Use !== "Old" && (
                  <DropDownList.Item value="Inactive">
                    Inactive
                  </DropDownList.Item>
                )}
                {!disableReplace && detailsMap.Use !== "Old" && (
                  <DropDownList.Item value="Replace">Replace</DropDownList.Item>
                )}
              </DropDownList>
            ))}
        </div>
        {extension && extension.length > 0 && (
          <div style={{ position: "relative", width: divWidth, float: "left" }}>
            <LinkButton
              icon="process"
              onClick={() => setOverrideOptions(!overrideOptions)}
              style={{ color: "mediumvioletred" }}
            />
            <ButtonList
              className={`${styles.overrideOutsideButton} ${
                overrideOptions ? styles.isVisible : ""
              }`}
              vertical
              spacing="0.2"
            >
              <LinkButton
                className={styles.insidebutton}
                onClick={() => onClickRecordOverrideButton()}
              >
                <p>View this attribute override</p>
              </LinkButton>
              <LinkButton
                className={styles.insidebutton}
                onClick={() => onClickRecordOverrideButton("all")}
              >
                <p>View summary of all overrides</p>
              </LinkButton>
            </ButtonList>
          </div>
        )}
      </div>
    );
  };

  const singleElementOverride = () => {
    return (
      <div>
        <div style={{ position: "relative", width: divWidth, float: "left" }}>
          {!extension ||
            (extension.length === 0 && (
              <LinkButton
                icon="menu_hidden"
                onClick={() => setRowPopOverVisible(!rowPopOverVisible)}
              />
            ))}
          {!extension ||
            (extension.length === 0 && (
              <ButtonList
                className={`${styles.overrideOutsideButton} ${
                  rowPopOverVisible ? styles.isVisible : ""
                }`}
                vertical
                spacing="0.2"
              >
                {!disableInactiiveAndInvalid && (
                  <LinkButton
                    className={styles.insidebutton}
                    onClick={event => handleOnclickAction(event, "Invalid")}
                  >
                    <p>Invalid</p>
                  </LinkButton>
                )}
                {!disableInactiiveAndInvalid && detailsMap.Use !== "Old" && (
                  <LinkButton
                    className={styles.insidebutton}
                    onClick={event => handleOnclickAction(event, "Inactive")}
                  >
                    <p>Inactive</p>
                  </LinkButton>
                )}
                {!disableReplace && detailsMap.Use !== "Old" && (
                  <LinkButton
                    className={styles.insidebutton}
                    onClick={event => handleOnclickAction(event, "Replace")}
                  >
                    <p>{"Replace"}</p>
                  </LinkButton>
                )}
              </ButtonList>
            ))}
        </div>
        {extension && extension.length > 0 && (
          <div style={{ position: "relative", width: divWidth, float: "left" }}>
            <LinkButton
              icon="process"
              onClick={() => setOverrideOptions(!overrideOptions)}
              style={{ color: "mediumvioletred" }}
            />
            <ButtonList
              className={`${styles.overrideOutsideButton} ${
                overrideOptions ? styles.isVisible : ""
              }`}
              vertical
              spacing="0.2"
            >
              <LinkButton
                className={styles.insidebutton}
                onClick={() => onClickRecordOverrideButton()}
              >
                <p>View this attribute override</p>
              </LinkButton>
              <LinkButton
                className={styles.insidebutton}
                onClick={() => onClickRecordOverrideButton("all")}
              >
                <p>View summary of all overrides</p>
              </LinkButton>
            </ButtonList>
          </div>
        )}
      </div>
    );
  };

  return isMultipleAttributeOverride
    ? multipleAttributeOverride()
    : singleElementOverride();
};

export default RecordOverrideOptions;
